export const FOOTER_COLUMN_WIDTH = '20rem'
